// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Spot from '../_raw/ui/icon_spot.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Spot);
